window.configReady.then(() => import('./app.js'))
